import type { z } from "zod";

export const getZodSafeParseErrorMessage = (
	result: z.ZodSafeParseResult<unknown>
): string | null => (result.success ? null : result.error.issues[0].message);
